import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectProviderDialogComponent } from './select-provider-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SelectProviderModule } from '../../select-provider/select-provider.module';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  imports: [CommonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatDividerModule, SelectProviderModule],
  declarations: [SelectProviderDialogComponent],
  exports: [SelectProviderDialogComponent]
})
export class SelectProviderDialogModule {}
